import React, { useEffect, useState } from 'react'
import useReport from './useReport'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import Box from '@mui/material/Box';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { formatAmount } from '../../utils/formatAmount';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import { formatDate } from '../../utils/dateUtils';

const NewCustomerReport = () => {

  const {reportData, isLoading, getNewCustomerPerformanceReport} = useReport()
  const [monthReportData, setMonthReportData] = useState([])

  useEffect(() => {
    getNewCustomerPerformanceReport()
  },[])


  useEffect(() => {
    console.log(reportData)
    reportData && groupAndSummarize(reportData)
  },[reportData])

  const getMonthYear = (dateString) => {
    const date = new Date(dateString);
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const year = date.getFullYear().toString().substring(2); // Last two digits of the year
    const month = monthNames[date.getMonth()];
    return `${month}-${year}`;
  };

  function formatMonth(dateString) {
    const date = new Date(dateString);
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const year = date.getFullYear().toString().substring(2); // Last two digits of the year
    const month = monthNames[date.getMonth()];
    return `${month}-${year}`;
  } 

  function Row({monthData, reportData}) {
    const [open, setOpen] = React.useState(false);
    // Function to filter the report data based on the month
    const filteredData = reportData.filter(item => 
      getMonthYear(item.regisMonth) === monthData.month
    );
    return (
      <React.Fragment>
        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row">
            {monthData?.month}
          </TableCell>
          <TableCell>{`${formatAmount(monthData.newCustomerCount)}`}</TableCell>
          <TableCell>{`${formatAmount(monthData.customerBuyItemCount)}`}</TableCell>
          <TableCell>{`${formatAmount(monthData.customerSendOnlyCount)}`}</TableCell>
          <TableCell>{`${formatAmount(monthData.newAmount)}`}</TableCell>
          <TableCell>{`${formatAmount(monthData.totalAmount)}`}</TableCell>
          <TableCell>{`${formatAmount(monthData.newWeight)}`}</TableCell>
          <TableCell>{`${formatAmount(monthData.totalWeight)}`}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={18}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Table size="small" aria-label="purchases">
                  <TableBody>
                    <TableRow>
                      <TableCell style={{fontWeight : 'bold'}} >Channel</TableCell>
                      <TableCell style={{fontWeight : 'bold'}} >จำนวนลูกค้า</TableCell>
                      <TableCell style={{fontWeight : 'bold'}} >จำนวนลูกค้าซื้อของ</TableCell>
                      <TableCell style={{fontWeight : 'bold'}} >จำนวนลูกค้าฝากส่ง</TableCell>
                      <TableCell style={{fontWeight : 'bold'}} >ค่าสินค้าเริ่มต้น (THB)</TableCell>
                      <TableCell style={{fontWeight : 'bold'}} >ค่าสินค้าสะสม (THB)</TableCell>
                      <TableCell style={{fontWeight : 'bold'}} >ค่าน้ำหนักเริ่มต้น (THB)</TableCell>
                      <TableCell style={{fontWeight : 'bold'}} >ค่าน้ำหนักสะสม (THB)</TableCell>
{/*                       <TableCell style={{fontWeight : 'bold'}} >ต้นทุนแลกเงิน</TableCell>
                      <TableCell style={{fontWeight : 'bold'}} >ต้นทุนค่าน้ำหนัก</TableCell>
                      <TableCell style={{fontWeight : 'bold'}} >กำไรเบื้องต้น</TableCell>
                      <TableCell style={{fontWeight : 'bold'}} >ค่าโฆษณา</TableCell>
                      <TableCell style={{fontWeight : 'bold'}} >กำไรรวม</TableCell> */}
                    </TableRow>
                  {filteredData && filteredData.map((row) => {
                    return (
                      <TableRow key={row.channel}>
                        <TableCell>{row.channel}</TableCell>
                        <TableCell>{`${formatAmount(row.newCustomerCount)}`}</TableCell>
                        <TableCell>{`${formatAmount(row.customerBuyItemCount)}`}</TableCell>
                        <TableCell>{`${formatAmount(row.customerSendOnlyCount)}`}</TableCell>
                        <TableCell>{`${formatAmount(row.newAmount)}`}</TableCell>
                        <TableCell>{`${formatAmount(row.totalAmount)}`}</TableCell>
                        <TableCell>{`${formatAmount(row.newWeight)}`}</TableCell>
                        <TableCell>{`${formatAmount(row.totalWeight)}`}</TableCell>
                      </TableRow>
                    );
                  })}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  const groupAndSummarize = (data) => {
    const groupedData = {};

    data.forEach(item => {
      const monthYear = formatMonth(item.regisMonth);
      if (!groupedData[monthYear]) {
        groupedData[monthYear] = {
          month: monthYear,
          newAmount: 0,
          totalAmount: 0,
          newWeight: 0,
          totalWeight: 0,
          avgPurchaseDays: 0,
          purchaseDays: 0,
          customerCount: 0,
          newCustomerCount: 0,
          customerBuyItemCount: 0,
          customerSendOnlyCount: 0,
          buyItemNewWeight: 0,
          buyItemTotalWeight: 0,
          sendOnlyNewWeight: 0,
          sendOnlyTotalWeight: 0
        };
      }
      // Summarize data
      groupedData[monthYear].newAmount += item.newAmount;
      groupedData[monthYear].totalAmount += item.totalAmount;
      groupedData[monthYear].newWeight += item.newWeight;
      groupedData[monthYear].totalWeight += item.totalWeight;
      groupedData[monthYear].purchaseDays += item.avgPurchaseDays * item.customerCount;
      groupedData[monthYear].customerCount += item.customerCount;
      groupedData[monthYear].newCustomerCount += Number(item.newCustomerCount);
      groupedData[monthYear].customerBuyItemCount += Number(item.customerBuyItemCount);
      groupedData[monthYear].customerSendOnlyCount += Number(item.customerSendOnlyCount);
      groupedData[monthYear].buyItemNewWeight += Number(item.buyItemNewWeight);
      groupedData[monthYear].buyItemNewWeight += Number(item.buyItemNewWeight);
      groupedData[monthYear].sendOnlyNewWeight += Number(item.sendOnlyNewWeight);
      groupedData[monthYear].sendOnlyTotalWeight += Number(item.sendOnlyTotalWeight);

      // ... summarize other fields
    });
    const dataArray = Object.values(groupedData);
    setMonthReportData(dataArray);
    //console.log(dataArray)
  }
  
  return (
    <TableContainer component={Paper}>
      <Table aria-label="table">
        <TableHead>
          <TableRow className='bg-indigo-600'>
            <TableCell/>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >เดือน</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >จำนวนลูกค้า</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >จำนวนลูกค้าซื้อของ</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >จำนวนลูกค้าฝากส่ง</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >ค่าสินค้าเริ่มต้น (THB)</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >ค่าสินค้าสะสม (THB)</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >ค่าน้ำหนักเริ่มต้น (THB)</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >ค่าน้ำหนักสะสม (THB)</TableCell>
{/*             <TableCell style={{ color: 'white', fontWeight : 'bold'}} >ต้นทุนแลกเงิน</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >ต้นทุนค่าน้ำหนัก</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >กำไรเบื้องต้น</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >ค่าโฆษณา</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >กำไรรวม</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {monthReportData && monthReportData.map((monthData) => (
            <Row 
              key={monthData.month} 
              monthData={monthData}
              reportData={reportData} 
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default NewCustomerReport